<header
  class="text-white bg-blue-1 d-flex justify-content-between align-items-center"
>
  <h1 class="mb-0 ms-3 p-3">E-Store Admin Portal</h1>
  <div class="me-3">
    <app-notification></app-notification>
  </div>
</header>
